import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }

import { computed } from 'vue'

// Components
import UnAuth from './UnAuth.vue'
import Auth from './Auth.vue'

// i18n
import { useI18n } from 'vue-i18n'
import useIsUserAuth from '@/hooks/useIsUserAuth'

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const { t } = useI18n()

const isAuthUser = computed<boolean>(()=> useIsUserAuth())


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    (isAuthUser.value)
      ? (_openBlock(), _createBlock(Auth, { key: 0 }))
      : (_openBlock(), _createBlock(UnAuth, { key: 1 }))
  ]))
}
}

})